// CareLogix™ ORACLE — Animated Signal Pulse (Phase 33 §7)
// Compact full-width pulse bar that visualizes the live signal heartbeat.
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PALETTE } from "@/components/animation/MotionShared";

export default function SignalPulse({ testid = "signal-pulse" }) {
  const [t, setT] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setT((v) => (v + 1) % 999), 90);
    return () => clearInterval(id);
  }, []);
  const bars = Array.from({ length: 48 }, (_, i) => {
    const phase = (i + t) % 48;
    const h = 6 + Math.abs(Math.sin(phase / 4)) * 30 + (i % 6 === 0 ? 8 : 0);
    return h;
  });
  return (
    <section style={S.shell} data-testid={testid} aria-label="Live signal pulse">
      <span style={S.label}>ORACLE SIGNAL PULSE™ · LIVE</span>
      <div style={S.barRow}>
        {bars.map((h, i) => (
          <motion.span
            key={i}
            style={{ ...S.bar, height: h, background: i % 8 === 0 ? PALETTE.gold : PALETTE.greenAccent }}
            transition={{ duration: 0.18 }}
          />
        ))}
      </div>
    </section>
  );
}

const S = {
  shell:   { background: "linear-gradient(90deg, rgba(8,32,22,0.55), rgba(4,6,8,0.85))", border: `1px solid ${PALETTE.goldGlow}`, borderRadius: 12, padding: "10px 14px", display: "flex", flexDirection: "column", gap: 6 },
  label:   { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.22em" },
  barRow:  { display: "flex", gap: 3, alignItems: "flex-end", height: 44 },
  bar:     { width: 4, borderRadius: 2, display: "block" },
};
